import {
  FileDownloadOutlined,
  ForwardToInbox,
  SaveAltOutlined,
  Visibility,
} from "@mui/icons-material";
import { Box, Button } from "@mui/material";
import { grey } from "@mui/material/colors";
import { isArray, isEmpty, isNil } from "lodash";
import { memo, useCallback, useMemo, useState } from "react";
import { useForm, useFormState } from "react-final-form";
import { useDispatch, useSelector } from "react-redux";

import { pdf } from "@react-pdf/renderer";
import { useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import FlxGrid from "../../../../../_src_shared/components/layout/FlxGrid";
import { formatDate } from "../../../../../_src_shared/utils/functions/formatDate";
import { formatPhone } from "../../../../../_src_shared/utils/functions/formatPhone";
import { removeEmptyObjectValues } from "../../../../../_src_shared/utils/objects/removeEmptyObjectValues";
import RffForm from "../../../../../components/finalForm/RffForm";
import RffPrimaryCardPdfPreview from "../../../../../components/finalForm/common/RffPrimaryCardPdfPreview";
import RffDollarField from "../../../../../components/finalForm/inputs/RffDollarField";
import RffSelectAutocompleteField from "../../../../../components/finalForm/inputs/RffSelectAutocompleteField";
import RffTextField from "../../../../../components/finalForm/inputs/RffTextField";
import RffTextareaField from "../../../../../components/finalForm/inputs/RffTextareaField";
import RffGroup from "../../../../../components/finalForm/shared/RffGroup";
import RffInputWrapper from "../../../../../components/finalForm/shared/RffInputWrapper";
import SelectAutoInput from "../../../../../components/inputs/SelectAutoInput";
import Flx from "../../../../../components/layout/Flx";
import FundingShieldPDF from "../../../../../components/pdf/FundingShieldPDF/FundingShieldPDF";
import Txt from "../../../../../components/typography/Txt";
import { loanDrilldownSidebarTypes } from "../../../../../constants/enums/loanDrilldownScreenSidebarOptions";
import { selectOptionsUsaStates } from "../../../../../constants/selectOptions/selectOptionsUsaStates";
import { useLoanFilesHook } from "../../../../../hooks/useLoanFilesHook";
import { usePdfDownloadHook } from "../../../../../hooks/usePdfDownloadHook";
import { loanDrilldownSet } from "../../../../../redux/actions/loanDrilldownActions";
import {
  sidebarSetStateValue,
  sidebarSetValues,
  sidebarTypeSet,
} from "../../../../../redux/actions/sidebarActions";
import { formatDollar } from "../../../../../utils/numbers/formatDollar";
import LoanDrilldownIconButtonAddContact from "../../../buttons/LoanDrilldownIconButtonAddContact";
const LoanFeesSubTabFundingShield = ({ onFeeItemClick }) => {
  // const [termsSheetData, setTermsSheetData] = useState(null);
  // const loanDrilldown = useSelector((state) => state.loanDrilldown);
  // const { loading, getLoanTerms, getFundingEntities } = useLoanTermsHook();
  // useEffect(() => {
  //   if (isNil(termsSheetData)) {
  //     getLoanTerms({
  //       dealId: loanDrilldown?._id,
  //       onSuccessFn: (data) => {
  //         console.log(data);
  //         setTermsSheetData(data);
  //       },
  //       onFailFn: (data) => {
  //         console.log(data);
  //         setTermsSheetData({});
  //       },
  //     });
  //   }
  // }, []);
  const loanTerms = useSelector((state) => state?.loanFetchedData?.loanTerms);
  const loanDrilldown = useSelector((state) => state.loanDrilldown);

  const initialValues = useMemo(() => {
    const init = {
      loanId: loanTerms?.loanId,
      lenderNameAndAddress: loanTerms?.fundingEntity?.mortgageeClause,

      "Borrower Type (Individual, Trust, or Entity)":
        loanDrilldown?.borrowerEntity?.entityType, //  terms.entityType (from root loan ? )
      // "Borrower Type (Individual, Trust, or Entity)": loanTerms?.entityType, //  terms.entityType (from root loan ? )

      guarantorNames: loanTerms?.guarantorNames,
      // borrowerName: loanTerms?.guarantorNames,
      borrowerEntityName: loanTerms?.entityName,
      subjectPropertyAddress: loanTerms?.propertyAddresses,
      // city: null,
      // state: null,
      // zip: null,
      totalLoanAmount: loanTerms?.totalLoanAmount, // "$612,450.00",
      accountManagerName: null,
      accountManagerEmail: null,
      accountManagerPhone: null,
      correspondent: null,
      correspondentPOCName: null,
      correspondentPOCEmail: null,
      closingAgentPOCName: isNil(loanTerms?.titleContact)
        ? null
        : `${loanTerms?.titleContact?.firstName} ${loanTerms?.titleContact?.lastName}`,
      closingAgentPOCEmailAddress: loanTerms?.titleContact?.emailAddress,

      // New Fields
      ClosingAgentAddress1: null,
      ClosingAgentCity: null,
      ClosingAgentName: null,
      ClosingAgentState: null,
      ClosingAgentZipCode: null,
    };

    return init;
  }, [loanTerms, loanDrilldown]);
  const headerSubtitle = useMemo(() => {
    const loanNumber = loanDrilldown?.loanNumber || "XXXXXX";
    const propertyAddress = !isArray(loanDrilldown?.subjectProperties)
      ? ""
      : loanDrilldown?.subjectProperties[0]?.address?.fullAddress;
    // const propertyAddress = "3112 North Stillman Street";
    return `Loan #${loanNumber} - ${propertyAddress}`;
  }, [loanDrilldown]);

  return (
    <RffPrimaryCardPdfPreview
      // loading={isNil(loanTerms)}
      // title="Letter of Intent"
      // formSpy
      filename={`Funding Shield - ${formatDate(new Date())}.pdf`}
      initialValues={initialValues}
      title="Funding Shield"
      subTitle={headerSubtitle}
      loading={isNil(loanTerms)}
      pdf={<FundingShieldPDF />}
      // initialValues={formInitialValues}
      // headerEndContent={<DownloadLetterOfIntentButton />}
    >
      <Box sx={{ mt: 2 }}>
        <RffFundingShieldFormQuestions />
        <Flx gap={1} fw sx={{ alignItems: "flex-start" }}>
          <UploadFundingShieldToLoanFilesButton />
          <SendFundingShieldEmailButton />
        </Flx>
      </Box>
    </RffPrimaryCardPdfPreview>
  );

  // return (
  //   <FundingShieldForm>
  //     <PrimaryContentCard
  //       maxWidth="md"
  //       title="Funding Shield"
  //       subTitle={headerSubtitle}
  //       loading={isNil(loanTerms)}
  //       endContent={<DownloadFundingShieldPdfButton />}
  //     >
  //       <Box sx={{ mt: 2 }}>
  //         <RffFundingShieldFormQuestions />
  //         <Flx gap={1} fw sx={{ alignItems: "flex-start" }}>
  //           <UploadFundingShieldToLoanFilesButton />
  //           <SendFundingShieldEmailButton />
  //         </Flx>
  //       </Box>
  //     </PrimaryContentCard>
  //   </FundingShieldForm>
  // );
};

const FundingShieldForm = ({ children }) => {
  const loanDrilldown = useSelector((state) => state.loanDrilldown);
  const loanTerms = useSelector((state) => state?.loanFetchedData?.loanTerms);
  const initialValues = useMemo(() => {
    const init = {
      loanId: loanTerms?.loanId,
      lenderNameAndAddress: loanTerms?.fundingEntity?.mortgageeClause,
      // lenderNameAndAddress:
      //   "Blue Ridge Capital LLC\nISAOA/ATIMA 290 Post Road West, Suite 100 Westport, CT 06880",

      // "Borrower Type (Individual, Trust, or Entity)": "Entity",
      "Borrower Type (Individual, Trust, or Entity)":
        loanDrilldown?.borrowerEntity?.entityType, //  terms.entityType (from root loan ? )
      // "Borrower Type (Individual, Trust, or Entity)": loanTerms?.entityType, //  terms.entityType (from root loan ? )

      guarantorNames: loanTerms?.guarantorNames,
      // borrowerName: loanTerms?.guarantorNames,
      borrowerEntityName: loanTerms?.entityName,
      subjectPropertyAddress: loanTerms?.propertyAddresses,
      // city: null,
      // state: null,
      // zip: null,
      totalLoanAmount: loanTerms?.totalLoanAmount, // "$612,450.00",
      accountManagerName: null,
      accountManagerEmail: null,
      accountManagerPhone: null,
      correspondent: null,
      correspondentPOCName: null,
      correspondentPOCEmail: null,
      closingAgentPOCName: isNil(loanTerms?.titleContact)
        ? null
        : `${loanTerms?.titleContact?.firstName} ${loanTerms?.titleContact?.lastName}`,
      closingAgentPOCEmailAddress: loanTerms?.titleContact?.emailAddress,

      // New Fields
      ClosingAgentAddress1: null,
      ClosingAgentCity: null,
      ClosingAgentName: null,
      ClosingAgentState: null,
      ClosingAgentZipCode: null,
    };

    return init;
  }, [loanTerms, loanDrilldown]);

  return (
    <RffForm
      // formSpy
      // sx={{ mt: 3 }}
      suppressFooter
      initialValues={initialValues}
    >
      {children}
    </RffForm>
  );
};

const RffFundingShieldFormQuestions = ({ children }) => {
  return (
    <>
      <RffGroup>
        <RffTextField name="loanId" label="Loan ID" />
        <RffTextareaField
          name="lenderNameAndAddress"
          label="Lender Name And Address"
        />
        <RffDollarField
          size={4}
          name="totalLoanAmount"
          label="Total Loan Amount"
        />
        <RffTextField
          size={4}
          name="Borrower Type (Individual, Trust, or Entity)"
          label="Borrower Type"
          helperText={"Individual, Trust, or Entity"}
        />

        <RffTextField
          size={4}
          name="borrowerEntityName"
          label="Borrower Entity Name"
        />

        <RffTextField name="guarantorNames" label="Guarantor Names" />
        <RffTextField
          name="subjectPropertyAddress"
          label="Subject Property Address"
        />

        <RffAccountManagerSelector>
          <RffTextField
            suppressGrid
            name="accountManagerName"
            label="Account Manager Name"
          />

          <RffTextField
            suppressGrid
            name="accountManagerEmail"
            label="Account Manager Email"
          />
          <RffTextField
            suppressGrid
            name="accountManagerPhone"
            label="Account Manager Phone"
          />
        </RffAccountManagerSelector>

        <RffTextField size={4} name="correspondent" label="Correspondent" />
        <RffTextField
          size={4}
          name="correspondentPOCName"
          label="Correspondent POC Name"
        />
        <RffTextField
          size={4}
          name="correspondentPOCEmail"
          label="Correspondent POC Email"
        />
      </RffGroup>
      <RffGroup title="Closing Agent Details (Required)" titleType="h3">
        <RffTextField name="ClosingAgentName" label="Closing Agent Name" />
        <RffTextField
          name="ClosingAgentAddress1"
          label="Closing Agent Address 1"
        />
        <RffTextField
          size={6}
          name="ClosingAgentCity"
          label="Closing Agent City"
        />
        <RffSelectAutocompleteField
          required
          size={3}
          options={selectOptionsUsaStates}
          name="ClosingAgentState"
          label="Closing Agent State"
        />
        <RffTextField
          size={3}
          name="ClosingAgentZipCode"
          label="Closing Agent Zip Code"
        />
      </RffGroup>
    </>
  );
};

const RffAccountManagerSelector = ({ name, label, size, children }) => {
  const [selectedId, setSelectedId] = useState(null);
  const loanDrilldown = useSelector((state) => state.loanDrilldown);
  const CUSTOM_TERM = "Custom Entry...";
  const dispatch = useDispatch();
  const { change } = useForm();
  const { values } = useFormState();

  const options = useMemo(() => {
    const loanRelatedContacts = loanDrilldown?.loanRelatedContacts || [];
    let mappedOptions = loanRelatedContacts?.map((contact) => {
      // return `(${contact.loanRole}) ${contact.firstName} ${contact.lastName}`;
      return {
        value: contact?._id,
        label: `(${contact?.loanRole}) ${contact?.firstName} ${contact?.lastName}`,
      };
    });
    return [
      ...mappedOptions,
      {
        value: CUSTOM_TERM,
        label: CUSTOM_TERM,
      },
    ];
    // return [...mappedOptions, "Custom Entry"];
  }, [loanDrilldown?.loanRelatedContacts]);

  const onChange = (id) => {
    if (isNil(id)) {
      change("accountManagerName", null);
      change("accountManagerEmail", null);
      change("accountManagerPhone", null);
      setSelectedId(null);
      return;
    }
    if (id === CUSTOM_TERM) {
      change("accountManagerName", null);
      change("accountManagerEmail", null);
      change("accountManagerPhone", null);
      setSelectedId(CUSTOM_TERM);
      return;
    }
    setSelectedId(id);
    const filteredContact = loanDrilldown?.loanRelatedContacts?.find(
      (contact) => contact._id === id
    );
    change(
      "accountManagerName",
      `${filteredContact.firstName} ${filteredContact.lastName}`
    );
    change("accountManagerEmail", filteredContact.emailAddress);
    change("accountManagerPhone", formatPhone(filteredContact.phone));
    return;
  };

  return (
    <RffInputWrapper
      size={size}
      // sx={{ border: `1px solid ${grey[100]}` }}
      label={"Account Manager"}

      // name={name}
      //
    >
      <LoanRelatedContactSelector
        value={selectedId}
        onChange={onChange}
        options={options}
      />

      {isNil(selectedId) ? null : (
        <FlxGrid
          gap={3}
          width="200px"
          sx={{
            p: 2,
            border: `1px solid ${grey[200]}`,
            borderRadius: 2,
            mt: 1,
            background: grey[50],
            ".MuiFormControl-root": {
              backgroundColor: "#ffffff",
            },
            label: {
              fontStyle: "italic",
              fontWeight: 400,
              fontSize: "12px",
            },
          }}
        >
          {children}
        </FlxGrid>
      )}
    </RffInputWrapper>
  );
};

const LoanRelatedContactSelector = ({ value, onChange, options }) => {
  const dispatch = useDispatch();
  const onContactAdd = useCallback(() => {
    dispatch(
      sidebarTypeSet(loanDrilldownSidebarTypes.ADD_LOAN_RELATED_CONTACT)
    );
    dispatch(sidebarSetStateValue(null));
  }, [dispatch]);
  return (
    <Flx ac gap={0.5} sx={{ flexGrow: 1, alignItems: "flex-end" }}>
      <SelectAutoInput
        value={value}
        sx={{ flexGrow: 1 }}
        onChange={onChange}
        fullWidth
        options={options}
      />
      <LoanDrilldownIconButtonAddContact onClick={onContactAdd} />
    </Flx>
  );
};

const DownloadFundingShieldPdfButton = memo(({}) => {
  const { values } = useFormState();
  const filename = useMemo(() => {
    return `${values.loanId}-funding-shield.pdf`;
  }, [values]);

  const convertFundingShieldData = (data) => {
    let convertedData = { ...values };

    convertedData.totalLoanAmount = formatDollar(values?.totalLoanAmount);
    return removeEmptyObjectValues(convertedData);
    // return convertedData;
  };
  const { downloadPDF, loading } = usePdfDownloadHook({
    formData: convertFundingShieldData(values),
    filename,
    type: "funding-shield",
  });

  return (
    <Button
      sx={{ flexGrow: 1 }}
      size="large"
      variant="outlined"
      startIcon={<FileDownloadOutlined className="thin" />}
      // startIcon={<PictureAsPdfOutlined className="thin" />}
      // startIcon={<ShieldOutlined />}
      onClick={downloadPDF}
    >
      Download (PDF)
      {/* Download As PDF */}
      {/* Download Funding Shield (PDF) */}
    </Button>
  );
});

const UploadFundingShieldToLoanFilesButton = memo(({}) => {
  const loanDrilldown = useSelector((state) => state.loanDrilldown);
  // const dispatch = useDispatch();
  const { loading, uploadLoanDocs } = useLoanFilesHook();
  const { values } = useFormState();
  const dispatch = useDispatch();

  const convertFundingShieldData = (data) => {
    let convertedData = { ...values };

    convertedData.totalLoanAmount = formatDollar(values?.totalLoanAmount);
    return removeEmptyObjectValues(convertedData);
  };
  const filtered = loanDrilldown?.loanDocuments.filter(
    (a) => a?.docType === "Funding Shield Request" && !a?.isHidden
  );

  const mostRecentFundingShield = useMemo(() => {
    const docs = loanDrilldown?.loanDocuments || [];
    const filtered = docs.filter(
      (a) => a?.docType === "Funding Shield Request" && !a?.isHidden
    );
    console.log("filtered", filtered);
    if (!filtered.length) return;

    const mostRecentFiltered = [...filtered].sort((a, b) => {
      const aTime = a?.uploadDate ? new Date(a.uploadDate).getTime() : 0;
      const bTime = b?.uploadDate ? new Date(b.uploadDate).getTime() : 0;
      return bTime - aTime; // newest first
    })[0];

    console.log("mostRecentFiltered", mostRecentFiltered);
    return mostRecentFiltered;
    if (mostRecentFiltered?._id && (!docs || docs.length === 0)) {
      return mostRecentFiltered;
      // setAttachments([mostRecentFiltered._id]);
    }
  }, [loanDrilldown?.loanDocuments]);
  const onSubmit = async () => {
    const blob = await pdf(
      <FundingShieldPDF formData={convertFundingShieldData(values)} />
    ).toBlob();

    // 2) Turn Blob into a File
    const file = new File([blob], "funding-shield.pdf", {
      type: "application/pdf",
    });

    // 3) Wrap into your standard file object shape
    const fileObj = {
      id: uuidv4(),
      file,
      name: file.name,
      file_display_name: `Funding Shield - ${formatDate(new Date())}.pdf`, // <- use whatever display name you want
      docGroup: "Title Docs", // optional if your backend wants it
      docType: "Funding Shield Request", // optional if your backend wants it
    };

    // console.log("fileObj", fileObj);
    // return;
    uploadLoanDocs({
      loanId: loanDrilldown?._id,
      files: [fileObj], // <- IMPORTANT: pass wrapped objects, not raw File

      onSuccessMsg: "Funding Shield saved to Loan Files",
      onSuccessFn: (data) => {
        dispatch(loanDrilldownSet(data));
      },
    });
  };
  const onPreviewClick = useCallback(() => {
    dispatch(
      sidebarSetValues({
        type: "filePreview",
        state: mostRecentFundingShield,
      })
    );
  }, [dispatch, mostRecentFundingShield]);
  return (
    <>
      <Button
        size="large"
        sx={{ flexGrow: 1 }}
        loading={loading}
        variant={isEmpty(filtered) ? "contained" : "outlined"}
        endIcon={<SaveAltOutlined sx={{ fontSize: "18px !important" }} />}
        // startIcon={<SaveAltOutlined />}
        // endIcon={<SaveAltOutlined sx={{ fontSize: "16px !important" }} />}
        // endIcon={<UploadFileOutlined sx={{ fontSize: "16px !important" }} />}
        onClick={onSubmit}
      >
        Save to Loan Files
      </Button>
      {!isEmpty(filtered) && !isNil(mostRecentFundingShield) && (
        <Button
          size="large"
          sx={{ flexGrow: 1 }}
          variant={"outlined"}
          endIcon={<Visibility sx={{ fontSize: "18px !important" }} />}
          // startIcon={<SaveAltOutlined />}
          // endIcon={<SaveAltOutlined sx={{ fontSize: "16px !important" }} />}
          // endIcon={<UploadFileOutlined sx={{ fontSize: "16px !important" }} />}
          onClick={onPreviewClick}
        >
          View Existing Funding Shield
        </Button>
      )}
    </>
  );
});

const SendFundingShieldEmailButton = memo(({}) => {
  const loanDrilldown = useSelector((state) => state.loanDrilldown);
  // const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, uploadLoanDocs } = useLoanFilesHook();
  const { values } = useFormState();
  const dispatch = useDispatch();

  const convertFundingShieldData = (data) => {
    let convertedData = { ...values };

    convertedData.totalLoanAmount = formatDollar(values?.totalLoanAmount);
    return removeEmptyObjectValues(convertedData);
  };

  const filtered = loanDrilldown?.loanDocuments.filter(
    (a) => a?.docType === "Funding Shield Request" && !a?.isHidden
  );

  const onSubmit = async () => {
    navigate(`/loan/${loanDrilldown?.loanNumber}/communication/funding-shield`);
  };
  return (
    <Flx center column sx={{ flexGrow: 1 }}>
      <Button
        size="large"
        fullWidth
        disabled={isEmpty(filtered)}
        loading={loading}
        endIcon={<ForwardToInbox />}
        onClick={onSubmit}
      >
        Email Funding Shield
      </Button>
      {isEmpty(filtered) && (
        <Txt secondary sx={{ fontSize: "12px", mt: 0.5 }}>
          Please save Funding Shield to loan before emailing
        </Txt>
      )}
      {/* <Txt secondary sx={{ fontSize: "12px", mt: 0.5 }}>
        {isEmpty(filtered)
          ? // ? "Uploaded Funding Shield required first"
            "Please save Funding Shield before emailing"
          : `Ready to email Funding Shield (${filtered?.length} uploaded)`}
      </Txt> */}
    </Flx>
  );
});

export default LoanFeesSubTabFundingShield;
